import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import ReactTooltip from "react-tooltip";

import MainUtils from "../main/MainUtils";
import '../styles/tables.css';
import '../styles/section.css';
import tooltips from '../tooltips';
import ChartTitle from '../components/ChartTitle';
import UIUtils from '../util/UIUtils';
import CoinUtils from '../util/CoinUtils';
import NetworkUtils from './NetworkUtils';
import StakeUtils from '../util/StakeUtils';

class NetworkInline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    }
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  // <h3>{LogoUtils.projectLogo(this.props.network.logo, this.props.network)} {NetworkUtils.networkFormatter(this.props.network.name, this.props.network)}</h3>
  // <p>{ProjectUIUtils.formatMediaSmall(null, this.props.network)}</p>
  // <div>{this.props.network.desc}</div>

  render() {
    return (
      <React.Fragment>
        <ReactTooltip id="main" place="top" type="dark" effect="float" multiline={true} />
        <Container fluid className="containerLayout container-fluid chartContainer">
          <div class="chartGridContainer">
            <div class="chartBg">{this.renderDecentralizationMetrics()}</div>
            <div class="chartBg">{this.renderNetworkDetails()}</div>
            <div class="chartBg">{this.renderDelegationDetails()}</div>
            {this.renderUndelegationDetails()}
            {this.renderUsageDetails()}
          </div>
        </Container>

        {this.props.network.analyticsWebsite && this.props.network.analyticsWebsite != "" && NetworkUtils.renderButton("Analytics Dashboard", this.props.network.analyticsWebsite, true)}
        <p/>
      </React.Fragment>
    );
  }

  renderNetworkDetails() {
    return (
      <React.Fragment>
        <ChartTitle title="Network Details" tip={tooltips.network.details} />
        <table>
          <tbody>
            <tr>
              <td>Market Cap: </td>
              <td> {UIUtils.coingeckoLinkFromMcap(this.props.network.usdMcap, this.props.network)}</td>
            </tr>
            <tr>
              <td>Token: </td>
              <td> {this.props.network.tokenSymbol}</td>
            </tr>
            <tr>
              <td>Total Supply: </td>
              <td> {CoinUtils.stakeFormatterRoundIfNeeded(this.props.network.totalSupply, this.props.network)} {this.props.network.tokenSymbol}</td>
            </tr>
            <tr>
              <td>Number of Validators: </td>
              <td> {this.props.network.consensusValidators}</td>
            </tr>
            <tr>
              <td>Addresses (&gt;0 balance): </td>
              <td> {NetworkUtils.activeAccountFormatter(this.props.network.activeAccounts, this.props.network)}</td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }

  renderUsageDetails() {
    if (!this.props.network.txCount24h) {
      return "";
    } 

    return (<div class="chartBg">
        <ChartTitle title="Usage Details" tip={tooltips.network.details} />
        <table>
          <tbody>
            <tr>
              <td>24h Active Addresses: </td>
              <td> {this.props.network.activeAddress24h}</td>
            </tr>
            <tr>
              <td>24h Transactions: </td>
              <td> {this.props.network.txCount24h}</td>
            </tr>
            <tr>
              <td>Successful/Failed Transactions: </td>
              <td> {this.props.network.successfulTxs + "/" + this.props.network.failedTxs}</td>
            </tr>
            <tr>
              <td>Recent Average Votes: </td>
              <td> {NetworkUtils.formatPropData(this.props.network.recentAvgVotes, this.props.network)}</td>
            </tr>
            <tr>
              <td>Successful/Failed Transactions: </td>
              <td> {NetworkUtils.formatPropData(this.props.network.recentMaxVotes, this.props.network)}</td>
            </tr>
          </tbody>
        </table>
    </div>);
  }

  renderDelegationDetails() {
    return (
      <React.Fragment>
        <ChartTitle title="Delegation Stats" tip={tooltips.network.delegations} />
        <table>
          <tbody>
            <tr>
              <td>Total Stake: </td>
              <td> {CoinUtils.stakeFormatterRoundIfNeeded(this.props.network.totalStake)} {this.props.network.tokenSymbol}</td>
            </tr>
            <tr>
              <td>Total Stake USD: </td>
              <td> {CoinUtils.tokenUsdValueFormatter(this.props.network.totalStakeUsd)}</td>
            </tr>
            <tr>
              <td>Staking APR: </td>
              <td> {CoinUtils.aprFormatter(this.props.network.currentRewardRate)}</td>
            </tr>
            <tr>
              <td>Unique Delegates / Unique Delegations: </td>
              <td> {this.getDelegateAndDelegations()}</td>
            </tr>
            <tr>
              <td>Average Delegation: </td>
              <td> {StakeUtils.formatAverageDelegationUsd(this.props.network.averageDelegation, this.props.network)}</td>
            </tr>
            <tr>
              <td>Percent Staked: </td>
              <td> {CoinUtils.percentFormatter(this.props.network.percentStaked)}</td>
            </tr>
            <tr>
              <td>Median/Weighted Median Commission: </td>
              <td> {MainUtils.percentFormatter(this.props.network.medianFee)} / {MainUtils.percentFormatter(this.props.network.weightedMedianCommission)}</td>
            </tr>
            <tr>
              <td>Top 100 Delegate Stake Share: </td>
              <td> {CoinUtils.percentFormatter(this.props.network.top100StakeShare)}</td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }

  renderUndelegationDetails() {
    if (!this.props.network.totalUndelegationAmount) {
      return "";
    } 

    return (
      <div class="chartBg">
        <ChartTitle title="Undelegation Stats" tip={tooltips.network.undelegations} />
        <table>
          <tbody>
            <tr>
              <td>Pending Undelegation Amount: </td>
              <td> {CoinUtils.stakeFormatterRoundIfNeeded(this.props.network.totalUndelegationAmount)} {this.props.network.tokenSymbol}</td>
            </tr>
            <tr>
              <td>Pending Undelegation Count: </td>
              <td> {this.props.network.uniqueUndelegations}</td>
            </tr>
            <tr>
              <td>Undelegation Amount % of Total Supply: </td>
              <td> {CoinUtils.percentFormatter(this.props.network.undelPercentOfTotalSupply)}</td>
            </tr>
            <tr>
              <td>Undelegation Amount % of Not Staked Supply: </td>
              <td> {CoinUtils.percentFormatter(this.props.network.undelPercentOfNotStakedSupply)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
  

  getDelegateAndDelegations() {
    if (!this.props.network.uniqueDelegates || !this.props.network.uniqueDelegations) {
      return "N/A";
    }

    if (this.props.network.symbol === "ROSE" || this.props.network.symbol === "IOTX" || this.props.network.symbol === "FRA") {
      return "N/A";
    }

    return this.props.network.uniqueDelegates + "/" + this.props.network.uniqueDelegations;
  }

  renderDecentralizationMetrics() {
    return (
      <React.Fragment>
        <ChartTitle title="Decentralization Metrics" tip={tooltips.network.metrics} />
        <table>
          <tbody>
            <tr>
              <td>Average Voting Power: </td>
              <td> {CoinUtils.usdFormatter(this.props.network.avgVotingPower)}</td>
            </tr>
            <tr>
              <td>Validators below Average Voting Power: </td>
              <td> {this.props.network.valBelowAvgPower}</td>
            </tr>
            <tr>
              <td>Nakamoto Coefficient: </td>
              <td> {NetworkUtils.formatNakamoto(this.props.network.nakamotoIndex)}</td>
            </tr>
            <tr>
              <td>Gini Coefficient: </td>
              <td> {NetworkUtils.formatGini(this.props.network.gini)}</td>
            </tr>
            <tr>
              <td>Top 1 equals bottom N Validators</td>
              <td> {this.props.network.oneEqualsNBottomValPercent}% / {this.props.network.oneEqualsNBottomVal}</td>
            </tr>
            <tr>
              <td>Last Active Validator Stake</td>
              <td> {this.props.network.lastValStake + " $" + this.props.network.tokenSymbol + 
                      (this.props.network.lastValStakeUsd != null ? ("/ $" + this.props.network.lastValStakeUsd) : "")}</td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default NetworkInline;



// WEBPACK FOOTER //
// ./src/network/NetworkInline.js